/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Placeholder_TitleInputs */

const en_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const de_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const fr_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeur Frontend Senior`)
};

const es_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const it_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const nl_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const pl_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const fi_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const da_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

const sv_jobs_placeholder_title = /** @type {(inputs: Jobs_Placeholder_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior Frontend Engineer`)
};

/**
* | output |
* | --- |
* | "Senior Frontend Engineer" |
*
* @param {Jobs_Placeholder_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_placeholder_title = /** @type {((inputs?: Jobs_Placeholder_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Placeholder_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_placeholder_title(inputs)
	if (locale === "fr") return fr_jobs_placeholder_title(inputs)
	if (locale === "es") return es_jobs_placeholder_title(inputs)
	if (locale === "it") return it_jobs_placeholder_title(inputs)
	if (locale === "nl") return nl_jobs_placeholder_title(inputs)
	if (locale === "pl") return pl_jobs_placeholder_title(inputs)
	if (locale === "fi") return fi_jobs_placeholder_title(inputs)
	if (locale === "da") return da_jobs_placeholder_title(inputs)
	if (locale === "sv") return sv_jobs_placeholder_title(inputs)
	return en_jobs_placeholder_title(inputs)
});